module.exports = __webpack_public_path__ + "img/VehiculoDatos.802c9e9a.svg";